/**
 * @module ftue/api
 *
 * Non-hook callers for the FTUE-state endpoints. The generated client
 * (`src/lib/endpoints.ts`) exposes these as React Query hooks
 * (`useUsersMarkFtueInitiated` / `useUsersSetFtueState`), but the completion
 * store's `markCompleted` seam and the shell's mount effect fire them
 * without React Query bookkeeping, so these thin module-level callers
 * exist — consuming the generated types so nothing is re-spelled.
 */
import { AXIOS_INSTANCE } from '@/lib/use-custom-instance';
import { authClient } from '@/auth';
import type { FtueOutcome } from '@/lib/models';

export type { FtueOutcome };

/**
 * Stamp that the FTUE was first shown. Server-side first-write-wins — safe to
 * fire on every shell mount.
 */
export function persistFtueInitiated(): Promise<unknown> {
  return AXIOS_INSTANCE({
    url: '/users/me/ftue-initiated',
    method: 'PUT',
    headers: { ...authClient.getAuthHeaders() },
  });
}

/**
 * Record how the one-shot FTUE resolved. Server-side first-write-wins, so
 * retries and multi-tab races are harmless.
 */
export function persistFtueState(outcome: FtueOutcome, variant: string): Promise<unknown> {
  return AXIOS_INSTANCE({
    url: '/users/me/ftue-state',
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authClient.getAuthHeaders() },
    data: { outcome, variant },
  });
}
